
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2QW4M", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $155c7596e61d6af0$export$a3c0845f856d4292);
$parcel$export(module.exports, "default", () => $155c7596e61d6af0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $155c7596e61d6af0$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("hlol8")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/ui/profilecard/index.tsx"
});
const $155c7596e61d6af0$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($155c7596e61d6af0$var$LazyComponent, props)));
var $155c7596e61d6af0$export$2e2bcd8739ae039 = $155c7596e61d6af0$export$a3c0845f856d4292;

});
parcelRegister("gcl1l", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $ecfe970d67067a10$export$c7209ce2e0d060ea);

var $bCf8q = parcelRequire("bCf8q");
const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $bCf8q.isLoaderError)(error)
    });

});

parcelRegister("hlol8", function(module, exports) {

let $03422e91713ba064$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $03422e91713ba064$var$load("ffQaD"),
    $03422e91713ba064$var$load("kvRbA"),
    $03422e91713ba064$var$load("czifk")
]).then(()=>parcelRequire('kKeZ6'));

});



$parcel$global.rlb("kcs34")
//# sourceMappingURL=async.a9a58bc9.js.map
